import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-alarm-warning-fill',
    title: 'Emergency Electrician',
    desc: 'Got an urgent electrical problem? We respond fast to power faults, tripping circuits, sparking sockets, and other electrical issues across Worksop and nearby areas.',
    iconBg: 'bg-navy-700',
  },
  {
    icon: 'ri-loop-left-fill',
    title: 'Full Rewiring',
    desc: 'Complete house rewiring carried out to the highest standard. Safe, certified, and covered by our workmanship guarantee.',
    iconBg: 'bg-navy-700',
  },
  {
    icon: 'ri-dashboard-fill',
    title: 'Fuse Board Upgrade',
    desc: 'Outdated fuse boards replaced with modern consumer units. Essential for safety and required for home insurance in many cases.',
    iconBg: 'bg-navy-700',
  },
  {
    icon: 'ri-file-check-fill',
    title: 'EICR Certificate',
    desc: 'Electrical Installation Condition Reports for landlords, homeowners, and buyers. Fast turnaround and official certification.',
    iconBg: 'bg-navy-700',
  },
  {
    icon: 'ri-home-gear-fill',
    title: 'Domestic Electrician',
    desc: 'All general electrical work for your home — sockets, lighting, outdoor electrics, electric vehicle chargers and more.',
    iconBg: 'bg-navy-700',
  },
  {
    icon: 'ri-lightbulb-flash-fill',
    title: 'Lighting Installation',
    desc: 'From LED downlights to outdoor security lighting, we design and install lighting solutions to transform any room or outdoor space.',
    iconBg: 'bg-navy-700',
  },
];

export default function ServicesOverview() {
  return (
    <section className="py-20 bg-cream font-body">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-gold-100 text-gold-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 border border-gold-200">
            Our Services
          </span>
          <h2 className="font-heading font-extrabold text-navy-800 mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
            Expert Electrical Services in Worksop
          </h2>
          <p className="text-navy-600/60 text-base max-w-2xl mx-auto leading-relaxed">
            Whether it&apos;s an emergency callout or a planned installation, we deliver professional electrical work across Worksop and Nottinghamshire.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="bg-white rounded-xl p-7 border border-gold-200/60 hover:border-gold-400 transition-all group cursor-pointer"
            >
              {/* Icon */}
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${svc.iconBg} mb-5 group-hover:bg-gold-400 transition-colors`}>
                <i className={`${svc.icon} text-gold-400 group-hover:text-navy-800 text-2xl transition-colors`}></i>
              </div>
              {/* Content */}
              <h3 className="font-heading font-bold text-navy-800 text-xl mb-3">{svc.title}</h3>
              <p className="text-navy-600/60 text-sm leading-relaxed mb-5">{svc.desc}</p>
              <Link
                to="/services"
                className="inline-flex items-center gap-1.5 text-gold-500 hover:text-gold-400 font-semibold text-sm transition-colors cursor-pointer"
              >
                Learn More
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 bg-navy-800 hover:bg-navy-700 text-white font-bold text-sm px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Services
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
